export default "__VITE_ASSET__1SLPuhRo__"